module.exports = __webpack_public_path__ + "static/media/image1.facaf32f.png";